__turbopack_context__.v({
  "iconWrapper": "TimelineBlock-module__48xPhG__iconWrapper",
  "line": "TimelineBlock-module__48xPhG__line",
  "material-icons": "TimelineBlock-module__48xPhG__material-icons",
  "timeline_block": "TimelineBlock-module__48xPhG__timeline_block",
  "timeline_block__inner": "TimelineBlock-module__48xPhG__timeline_block__inner",
  "timeline_label": "TimelineBlock-module__48xPhG__timeline_label",
  "timeline_text": "TimelineBlock-module__48xPhG__timeline_text",
  "timeline_title": "TimelineBlock-module__48xPhG__timeline_title",
  "timelineiconbox": "TimelineBlock-module__48xPhG__timelineiconbox",
  "timelineinfobox": "TimelineBlock-module__48xPhG__timelineinfobox",
  "timelinerow": "TimelineBlock-module__48xPhG__timelinerow",
});
